import { FormlyExtension, FormlyFieldConfig } from '@ngx-formly/core';
import {
  FILL_HEIGHT_FLEX_CHAIN_CLASS,
  PHX_FORMLY_FILL_HEIGHT_MARKER_CLASS,
} from '../../shared/layout/page-fill-host.classes';

function mergeClassNames(existing: string | undefined, toAdd: string): string {
  const tokens = new Set([
    ...(existing ?? '').split(/\s+/).filter(Boolean),
    ...toAdd.split(/\s+/).filter(Boolean),
  ]);
  return [...tokens].join(' ');
}

/** True when the field already declares an explicit flex fill layout. */
function hasFillHeightLayoutClass(className: string | undefined): boolean {
  if (!className) {
    return false;
  }
  return className.includes('min-h-0') && className.includes('flex-1');
}

const FORMLY_FILL_HEIGHT_FIELD_CLASS =
  `${PHX_FORMLY_FILL_HEIGHT_MARKER_CLASS} ${FILL_HEIGHT_FLEX_CHAIN_CLASS}`;

/**
 * When {@link FormlyFieldConfig.props.fillHeight} is true, applies
 * {@link PHX_FORMLY_FILL_HEIGHT_MARKER_CLASS} + {@link FILL_HEIGHT_FLEX_CHAIN_CLASS}
 * to the field group and its single list child.
 * Tab panels also get classes from {@link FormlyTabsComponent} and page-fill-layout SCSS.
 */
export class FillHeightFormlyExtension implements FormlyExtension {
  prePopulate(field: FormlyFieldConfig): void {
    if (!field.props?.fillHeight) {
      return;
    }

    const group = field.fieldGroup;
    // Leaf list tab (type on the tab field itself)
    if (!group?.length) {
      if (!hasFillHeightLayoutClass(field.className)) {
        field.className = mergeClassNames(field.className, FORMLY_FILL_HEIGHT_FIELD_CLASS);
      } else {
        field.className = mergeClassNames(field.className, PHX_FORMLY_FILL_HEIGHT_MARKER_CLASS);
      }
      return;
    }

    field.fieldGroupClassName = mergeClassNames(
      field.fieldGroupClassName,
      FORMLY_FILL_HEIGHT_FIELD_CLASS,
    );

    if (group.length === 1) {
      const child = group[0];
      if (!hasFillHeightLayoutClass(child.className)) {
        child.className = mergeClassNames(child.className, FORMLY_FILL_HEIGHT_FIELD_CLASS);
      } else {
        child.className = mergeClassNames(child.className, PHX_FORMLY_FILL_HEIGHT_MARKER_CLASS);
      }
    }
  }
}

export function fillHeightExtension() {
  return {
    extensions: [{
      name: 'fillHeight',
      extension: new FillHeightFormlyExtension(),
    }],
  };
}
